// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__2frsx","badge_disable":"Badge_badge_disable__3km3j"};